export const SHOW_MODAL = "SHOW_MODAL";
export const HIDE_MODAL = "HIDE_MODAL";
export const CLEAR_MODAL_DATA = "CLEAR_MODAL_DATA";
export const SHOW_MODAL_ERROR = "SHOW_MODAL_ERROR";
